"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "removeItemFromCart", {
    enumerable: true,
    get: ()=>removeItemFromCart
});
const _graphqlRequest = require("graphql-request");
const _checkoutFragment = require("../fragments/checkout-fragment");
const removeItemFromCart = (0, _graphqlRequest.gql)`
    mutation RemoveItemFromCheckout(
        $retailerId: ID!
        $checkoutId: ID!
        $itemId: ID!
    ) {
        removeItem(
            retailerId: $retailerId
            checkoutId: $checkoutId
            itemId: $itemId
        ) {
            ...checkoutFragment
        }
    }
    ${_checkoutFragment.CHECKOUT_FRAGMENT}
`;
